import { ComboBoxProps, FormInput } from '@acsbe/ui';
import { ReactNode } from 'react';
import {
  FieldValues,
  UseControllerProps,
  useController,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useGetFormError } from '../../utils';

export function FormComboBox<Form extends FieldValues>({
  children,
  label,
  autocomplete = false,
  placeholder,
  required,
  layout,
  'aria-autocomplete': ariaAutocomplete,
  'aria-label': ariaLabel,
  onEvent,
  ...props
}: UseControllerProps<Form> &
  Pick<
    ComboBoxProps,
    | 'autocomplete'
    | 'placeholder'
    | 'required'
    | 'aria-autocomplete'
    | 'aria-label'
  > & {
    children: ReactNode;
    label?: string;
    layout?: 'horizontal' | 'vertical';
    onEvent?: Function;
  }) {
  const { field, formState } = useController(props);
  const { t } = useTranslation();
  const getFormError = useGetFormError(formState);
  const error = getFormError(props.name);

  return (
    <FormInput
      type="$combobox"
      wrap
      autocomplete={autocomplete}
      placeholder={
        placeholder &&
        (typeof placeholder === 'string' ? t(placeholder) : placeholder)
      }
      aria-invalid={!!error}
      description={error}
      required={required}
      aria-autocomplete={ariaAutocomplete}
      aria-label={ariaLabel}
      label={label && t(label)}
      layout={layout}
      {...field}
      onChange={(e: string) => {
        field.onChange(e);
        onEvent && onEvent(e, 'change');
      }}
    >
      {children}
    </FormInput>
  );
}
